/**
 * `flow-plays` React Query key root (plan
 * `plans/2026-09-09-003-terra-signals-plays-tab-plan.md` U4/D14).
 *
 * Split into its own tiny module — not colocated with `hooks.ts`, which is
 * where it's actually consumed as a queryKey — for the same reason
 * `contact-state-keys.ts` isn't colocated with `contact/hooks.ts` (see that
 * file's doc comment): `EnrollQueueContext.tsx` must invalidate this key
 * after queue mutations so counts refresh without a TTL (D14), and it should
 * import just the root, not `hooks.ts` and everything `hooks.ts` pulls in.
 *
 * `hooks.ts` spreads this root into `useFlowPlays`'s queryKey
 * (`[...FLOW_PLAYS_QUERY_KEY, params]`) so the root segment can never drift
 * between the query definition and any invalidation call site.
 */

export const FLOW_PLAYS_QUERY_KEY = ['flow-plays'] as const;
